<template>
    <div if="wire-general" >
      <vx-card no-shadow v-if="showWindow">
        <div class="flex flex-wrap justify-between items-center">
          <draggable v-model="fieldsData" @start="drag=true" @end="saveSort()" class="vx-row mb-4" >
              <div class="vx-row mb-4" v-for="(item) in fieldsData" :key="item.order" v-show="item.name!=='phone2' && item.name!=='timestamp'">
                  <div class="vx-col w-full">
                    {{item.name}} <vs-button radius color="primary" class="inline-block" type="flat"  icon="content_copy" @click="copyToClipBoard(item.name)"></vs-button>
                    <br />
                    <vs-input class="inputx inline-block" size="normal" v-model="params[item.name]" :readonly="isReadOnly(item.name)"/>&nbsp;
                  </div>
              </div>      
            </draggable>
        </div>
  
        <!-- Save & Reset Button -->
        <div class="flex flex-wrap items-center justify-end">
          <vs-button disabled @click="sendData('update-client')" class="ml-auto mt-2">Save Changes</vs-button>
        </div>
      </vx-card>
      <!--
      <vx-card no-shadow v-if="showWindow">
        <h3>Deposits</h3>
        <vs-table max-items="5" pagination :data="tableData">
            <template slot="thead">
                <vs-th v-for="(item,index) in fieldsHead" :key="index">{{item}}</vs-th>
            </template>
  
            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td  v-for="(item,index) in fieldsHead" :key="index" :data="data[indextr][item]">
                        {{data[indextr][item]}}
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
      </vx-card>
  
      <vx-card no-shadow v-if="showWindow">
        <h3>Agent actions log</h3>
        <vs-table max-items="5" pagination :data="tableData2">
            <template slot="thead">
                <vs-th v-for="(item,index) in fieldsHead2" :key="index">{{item}}</vs-th>
            </template>
  
            <template slot-scope="{data}">
                <vs-tr :key="indextr" v-for="(tr, indextr) in data">
                  <vs-td  v-for="(item,index) in fieldsHead2" :key="index" :data="data[indextr][item]">
                        {{data[indextr][item]}}
                    </vs-td>
                </vs-tr>
            </template>
        </vs-table>
      </vx-card>
        -->
    </div>
  </template>
  
  <script>
  import axios from "@/axios.js"
  import draggable from 'vuedraggable'
  export default {
    data() {
      return {
        isData: false,
        params:{},
        dataOrder: [],
        fieldsData:[],
        popupActive:false,
        editable:['email','Country','state','address','postal','city','phone1','phone2','first_name','last_name','dob'],
        tableData:[],
        fieldsHead: [],
        tableData2:[],
        fieldsHead2: []
      }
    },
    components: {
        draggable
    },
    computed: {
      showWindow(){
        if(this.$route.path.indexOf('/wire_details/')!==-1){
          if(!this.isData)
            this.setData();
          return true;
        }
        return false;
      },
    },
    methods:{
      saveSort: function(){
        this.drag=false;
            let counter = 1;
            for(let i in this.fieldsData){
              this.fieldsData[i].order = counter;
              counter++;
            }
            localStorage.setItem('clientDetails', JSON.stringify(this.fieldsData));
      },
      loadState: function(){
              this.dataOrder = JSON.parse(localStorage.getItem('clientDetails'));
      },
      copyToClipBoard: function(index){
        let that = this;
        let text = this.params[index];
        let textArea = document.createElement("textarea");
        textArea.value = text;
        document.body.appendChild(textArea);
        textArea.select();
        if(document.execCommand('copy'))
          that.openAlert('success','','copied to clipboard');
        document.body.removeChild(textArea);
      },
      isReadOnly: function(index){
          return this.editable.indexOf(index)===-1;
        },
        setData: function(){
           
          this.loadState();
          const params = new URLSearchParams();
        //  params.append('type', 'get-single-bank-details');
          params.append('bankId', this.$route.params.bankid);
          let that = this;
        //  this.setDepositsData();
         // this.setAgentLogData();
          axios.post("/api/clients",params)
          .then((response) => {
            
            that.params = response.data;
            let counter = 1;
            if(this.dataOrder!==null && this.dataOrder.length>0){
              for(let i in response.data){
                let order = this.dataOrder.length + counter;
                for(let j in this.dataOrder){
                  if(this.dataOrder[j].name===i){
                    order = this.dataOrder[j].order;
                    break;
                  }
                }                
                that.fieldsData.push({"name":i,"value":response.data[i],"order":order})
                counter++;
              }
            } else{
              for(let i in response.data){
                that.fieldsData.push({"name":i,"value":response.data[i],"order":counter})
                counter++;
              }
            }
            that.fieldsData.sort(function(a, b) {
              var x = a.order, y = b.order;
              // Compare the 2 dates
              if (x < y) return -1;
              if (x > y) return 1;
              return 0;
            });
            this.isData=true
          })
          .catch(() => { })
        },

        setDepositsData: function(){
          let that = this;
          const params = new URLSearchParams();
          params.append('type', 'deposits');
          params.append('uid', this.$route.params.email);
          axios.post("/api/client",params)
          .then((response) => {
            that.tableData.splice(0);
            for(let i in response.data){
              let data = JSON.parse(response.data[i].object);
              if(that.fieldsHead.length===0){
                  for(let i in data){
                      that.fieldsHead.push(i);
                  }
              }
              that.tableData.push(data);
            }
          })
          .catch(() => { })
        },
        setAgentLogData: function(){
          let that = this;
          const params = new URLSearchParams();
          params.append('type', 'agent-actions');
          params.append('uid', this.$route.params.email);
          axios.post("/api/client",params)
          .then((response) => {
            that.tableData.splice(0);
            for(let i in response.data){
              let data = JSON.parse(response.data[i].object);
              if(that.fieldsHead2.length===0){
                  for(let i in data){
                      that.fieldsHead2.push(i);
                  }
              }
              that.tableData2.push(data);
            }
          })
          .catch(() => { })
        },      
        sendData: function(type){
          let that = this;
          const params = new URLSearchParams();
          params.append('type', type);
          switch(type){
            case 'update-client':
              params.append('email', this.$route.params.email);
              params.append('first_name', this.params.first_name);
              params.append('last_name', this.params.last_name);
              params.append('phone_code1', this.params.phone_code1);
              params.append('phone1', this.params.phone1);
              params.append('address', this.params.address);
              params.append('city', this.params.city);
              params.append('state', this.params.state);
              params.append('Country', this.params.Country);
              params.append('postal', this.params.postal);
              break;
          }
          this.$vs.loading();
          axios.post("/api/client",params)
          .then((data) => {
            that.$vs.loading.close();
            if(data.data[0].out1==='done!'){
              that.openAlert('success','Success',data.data[0].out1);
              that.setData(true);
              that.popupActive = false;
              
            } else
              that.openAlert('danger','Failed',data.data[0].out1);
           })
          .catch((error) => { that.$vs.loading.close(); that.openAlert('danger','Failed',error[0].out1); })
        },
        openAlert(color,title,text) {
          let colorAlert = color;
          this.$vs.notify({
            title: title,
            text: text,
            color: colorAlert
          })
        },
      }
  }
  </script>